import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";
import { whatsappLink } from "@/data/site";

export const WhatsAppFloat = () => {
  return (
    <motion.a
      data-testid="floating-whatsapp-button"
      href={whatsappLink("Hola Ruta 360, vengo del sitio web y quiero información.")}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.8, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      aria-label="Abrir chat de WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.35)]"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring -z-10" />
      <WhatsappLogo size={28} weight="fill" />
    </motion.a>
  );
};
